(function (ng, app) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Tools.Applications",
                {
                    url: "/Applications",
                    component: "applicationsContainer",
                    PageTitle: "Applications",
                    redirectTo: "Home.Tools.Applications.EApps"
                });
        }
    ]);

    app.component("applicationsContainer",
        {
            templateUrl: "App/Tools/Applications/applications-template.html",
            controller: "applicationsController"
        });

    app.controller("applicationsController", [function () {
        var $ctrl = this;
    }]);

})(window.angular, window.app); // jshint ignore:line